/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Social_Google_SlowInputs */

const en_auth_social_google_slow = /** @type {(inputs: Auth_Social_Google_SlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Still connecting to Google...`)
};

const es_auth_social_google_slow = /** @type {(inputs: Auth_Social_Google_SlowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aun conectando con Google...`)
};

/**
* | output |
* | --- |
* | "Still connecting to Google..." |
*
* @param {Auth_Social_Google_SlowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const auth_social_google_slow = /** @type {((inputs?: Auth_Social_Google_SlowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Social_Google_SlowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_social_google_slow(inputs)
	return es_auth_social_google_slow(inputs)
});